/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

// eslint-disable-next-line import/prefer-default-export
export const STORE_CONFIG_KEY = 'config';

export const DEFAULT_STORE_CURRENCY_CONFIG = {
    pl: {
        currency: 'PLN',
        lang: 'pl'
    },
    en: {
        currency: 'EUR',
        lang: 'en'
    },
    fr: {
        currency: 'EUR',
        lang: 'fr'
    },
    de: {
        currency: 'EUR',
        lang: 'de'
    },
    cz: {
        currency: 'CZK',
        lang: 'cz'
    }
};
